__turbopack_context__.v({
  "active": "PageClient-module-scss-module__SHewUq__active",
  "btnMoreList": "PageClient-module-scss-module__SHewUq__btnMoreList",
  "itemList": "PageClient-module-scss-module__SHewUq__itemList",
  "listBlock": "PageClient-module-scss-module__SHewUq__listBlock",
  "on": "PageClient-module-scss-module__SHewUq__on",
  "scrollList": "PageClient-module-scss-module__SHewUq__scrollList",
  "scrollListExpanded": "PageClient-module-scss-module__SHewUq__scrollListExpanded",
});
